import { useParams } from 'react-router'
import Page from '@/components/common/Page'
import QueueTab from '@/pages/clients/ClientContent/QueueTab'

export default function QueuePage() {
  const { clientId } = useParams<{ clientId: string }>()

  if (!clientId) return null

  return (
    <Page
      title="Queue"
      helpContent={{
        header: 'Content Queue',
        body: (
          <div>
            <p>Review and approve generated content before it goes live. Quality control all marketing materials before publication.</p>
            <h4>Workflow:</h4>
            <ul style={{ marginLeft: 20 }}>
              <li><strong>Pending Review</strong> - Newly generated content awaiting approval</li>
              <li><strong>Scheduled</strong> - Content approved for future publication</li>
              <li><strong>Published</strong> - Content that has been published</li>
              <li><strong>Rejected</strong> - Content you rejected (will be regenerated)</li>
            </ul>
            <h4>How to Use:</h4>
            <p>Review content preview. Approve for immediate publishing or schedule for later. Reject with feedback to regenerate. This is your final quality gate.</p>
          </div>
        ),
      }}
    >
      <QueueTab clientId={clientId} />
    </Page>
  )
}
